export const captureUTM = () => {
  const params = new URLSearchParams(window.location.search);
  const utm = params.get('utm_source');
  if (utm) {
    sessionStorage.setItem('utm_source', utm);
  }
};

export const getUTM = () => sessionStorage.getItem('utm_source') || '';

export const appendUTM = (path) => {
  const utm = getUTM();
  return utm ? `${path}?utm_source=${utm}` : path;
};
